import { useCallback, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import RemisionDispatchMovementsUI from "./RemisionDispatchMovementsUI";
import { remisionService } from "@services/RemisionService";
import { createHeader, formatDate } from "@utils/utils";
import { IDispatchMovement } from "src/types/global";
const rowsPerPage = 10;
const RemisionDispatchMovements = () => {
  const {
    detailId
  } = useParams();
  const location = useLocation();
  const productName: string | undefined = location.state?.productName;
  const [movements, setMovements] = useState<IDispatchMovement[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const getDispatchMovements = useCallback(async (id: number) => {
    try {
      setIsLoading(true);
      const res = await remisionService.getDispatchMovements(id);
      setMovements(res.data);
    } catch {
      setMovements([]);
    } finally {
      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    if (!detailId) return;
    getDispatchMovements(Number(detailId));
  }, [detailId, getDispatchMovements]);
  const pages = Math.max(1, Math.ceil(movements.length / rowsPerPage));
  const rows = movements.slice(rowsPerPage * (currentPage - 1), rowsPerPage * currentPage).map(movement => ({
    dispatchedAt: formatDate(movement.dispatchedAt),
    quantity: movement.quantity,
    warehouseName: movement.warehouseName ?? "—",
    employeeName: movement.employeeName ?? "—"
  }));
  const headers = [createHeader("Fecha", "dispatchedAt"), createHeader("Cantidad despachada", "quantity"), createHeader("Bodega", "warehouseName"), createHeader("Despachado por", "employeeName")];
  return <RemisionDispatchMovementsUI title={productName ? `Despachos de ${productName}` : "Despachos"} subtitle="Detalle de cada despacho realizado para esta línea de producto." headers={headers} rows={rows} pages={pages} isLoading={isLoading} onChangePage={setCurrentPage} emptyMessage="Sin despachos registrados" />;
};
export default RemisionDispatchMovements;